import { initSwiperContainer } from "@modules/util/swiper.ts"
import type { SwiperContainer } from "swiper/element"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssNavigation from "swiper/element/css/navigation?raw"
import { Navigation, Pagination, Scrollbar } from "swiper/modules"
import type { SwiperOptions } from "swiper/types"
export class StarsProfileSwiper {
    private readonly userOptions?: SwiperOptions

    private container: SwiperContainer | null = null
    private swiper: SwiperContainer["swiper"] | null = null
    private nextButton: Element | null = null
    private prevButton: Element | null = null

    init(): void {
        this.resolveDomElements()

        if (!this.container) {
            console.error("No swiper container found for stars profile gallery swiper")
            return
        }

        const options: SwiperOptions = {
            slidesPerView: "auto",
            spaceBetween: 1,
            centeredSlides: false,
            centerInsufficientSlides: true,
            pagination: false,
            direction: "horizontal",
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
            modules: [Navigation, Pagination, Scrollbar],
            injectStyles: [swiperCssNavigation],
            ...(this.userOptions ?? {}),
        }

        initSwiperContainer(this.container, options as SwiperOptions)
        this.swiper = this.container.swiper

        this.bindSwiperEvents()
        this.updateButtonVisibility()
    }

    destroy(): void {
        if (this.swiper) {
            if (typeof this.swiper.destroy === "function") {
                this.swiper.destroy(true, true)
            }
        }

        if (this.nextButton) {
            this.nextButton.replaceWith(this.nextButton.cloneNode(true))
        }

        if (this.prevButton) {
            this.prevButton.replaceWith(this.prevButton.cloneNode(true))
        }

        this.swiper = null
        this.container = null
        this.nextButton = null
        this.prevButton = null
    }

    private resolveDomElements(): void {
        this.container = document.getElementById("upgradedStarProfileSwiperContainer") as SwiperContainer | null
    }

    private bindSwiperEvents(): void {
        if (!this.swiper) {
            return
        }

        this.swiper.on("resize", () => {
            this.updateButtonVisibility()
        })

        this.swiper.on("slideChange", () => {
            this.updateButtonVisibility()
        })

        this.swiper.on("afterInit", () => {
            const slides = this.swiper?.slides || []
            const halfwayIndex = Math.floor(slides.length / 2)

            this.swiper?.slideTo(halfwayIndex, 0)
            this.updateButtonVisibility()
        })
    }

    private updateButtonVisibility(): void {
        if (!this.swiper || !this.nextButton || !this.prevButton) {
            return
        }

        if (this.swiper.isEnd) {
            this.nextButton.classList.add("is-disabled")
        } else {
            this.nextButton.classList.remove("is-disabled")
        }

        if (this.swiper.isBeginning) {
            this.prevButton.classList.add("is-disabled")
        } else {
            this.prevButton.classList.remove("is-disabled")
        }
    }
}

const starsProfileSwiper = new StarsProfileSwiper()

starsProfileSwiper.init()
